import React from "react";
import "./row-separator.m.css";

export const RowSeparator = () => {
  return <div styleName="row-separator"></div>;
};
